// extracted by mini-css-extract-plugin
export default {"wrapper":"no","form":"oo","preference":"po","request":"qo","job":"ro","smallprint":"so","asterisk":"to","success":"uo","circle":"vo"};